import { memo } from 'react';

import { Box, Loader } from '@bonanza-social/moonlight';

function SplashScreen() {
  return (
    <Box backgroundColor="screenBackground" absoluteFill centerContent>
      <Loader />
    </Box>
  );
}

export default memo(SplashScreen);
